import type { CSSProperties, FC } from 'react';
import classNames from 'classnames';
import './index.scss';

export interface SimpleSkeletonProps {
    className?: string;
    style?: CSSProperties;
}

const SimpleSkeleton: FC<SimpleSkeletonProps> = ({ className, style }) => {
    const skeletonClassNames = classNames('simple-skeleton', className);

    return <div className={skeletonClassNames} style={style} />;
};

export default SimpleSkeleton;
